exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#countryField.ng-invalid{border-color:#bd3632;color:#bd3632}#countryField.ng-invalid option:not([disabled]){color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/buy-product/country-of-residence/country-of-residence.styl
// module id = 929
// module chunks = 0